import createVueApp from '@phoenix/createVueApp';

import { PhxsgAccordion, PhxsgAccordionContent, PhxsgAccordionItem, PhxsgAccordionTrigger } from './index';

document.querySelectorAll('.phxsg-accordion-container').forEach((el) => {
  const app = createVueApp();
  app.component('PhxsgAccordion', PhxsgAccordion);
  app.component('PhxsgAccordionItem', PhxsgAccordionItem);
  app.component('PhxsgAccordionTrigger', PhxsgAccordionTrigger);
  app.component('PhxsgAccordionContent', PhxsgAccordionContent);
  app.mount(el);
});
